import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const testimonials = [
  {
    name: "Michael T.",
    title: "Business Executive",
    quote:
      "I've used Sagar Luxury Ride for every airport run for the past year. Without fail — on time, immaculate vehicle, professional driver. This is the standard every car service should meet.",
    rating: 5,
  },
  {
    name: "Sarah K.",
    title: "Bride",
    quote:
      "They handled our entire wedding day transportation flawlessly. The vehicles were stunning and our driver was so gracious. Not a single thing to worry about — pure luxury from start to finish.",
    rating: 5,
  },
  {
    name: "David R.",
    title: "Corporate Client",
    quote:
      "My clients expect nothing but the best, and SLR delivers every time. The flat-rate pricing makes expensing easy and there's never a surprise. Highly recommend for corporate travel.",
    rating: 5,
  },
  {
    name: "Philip M.",
    title: "Lawyer",
    quote:
      "I have used SLR exclusively for the past 10 years for numerous different types of events. The quality of their drivers, service, reliability and luxury vehicles are unsurpassed. It is truly white glove service — you will not go wrong with SLR.",
    rating: 5,
  },
];

function Stars({ count }) {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <svg
          key={i}
          className="w-4 h-4"
          viewBox="0 0 20 20"
          fill="#c9a84c"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      ))}
    </div>
  );
}

function TestimonialCard({ t, index }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 32 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{
        duration: 0.75,
        ease: [0.22, 1, 0.36, 1],
        delay: index * 0.12,
      }}
      className="relative p-8 border border-white/5 flex flex-col gap-5 overflow-hidden"
      style={{ background: "#1a1a1a" }}
    >
      {/* Giant quote mark */}
      <span
        className="absolute -top-2 -left-1 font-display text-8xl md:text-9xl leading-none select-none pointer-events-none"
        style={{ color: "rgba(201,168,76,0.07)" }}
      >
        "
      </span>

      <Stars count={t.rating} />

      <p className="text-cream/75 text-sm md:text-base leading-relaxed italic font-light relative z-10">
        "{t.quote}"
      </p>

      <div className="flex items-center gap-3 pt-2 border-t border-white/5">
        <div
          className="w-9 h-9 border border-gold/30 flex items-center justify-center font-display text-gold text-sm font-semibold flex-shrink-0"
          style={{ background: "rgba(201,168,76,0.07)" }}
        >
          {t.name[0]}
        </div>
        <div>
          <p className="text-cream text-sm font-medium">{t.name}</p>
          <p className="text-cream/40 text-xs">{t.title}</p>
        </div>
      </div>
    </motion.div>
  );
}

export default function Testimonials() {
  const headingRef = useRef(null);
  const headingInView = useInView(headingRef, { once: true, margin: "-60px" });

  return (
    <section
      id="testimonials"
      className="py-24 md:py-32"
      style={{ background: "#0a0a0a" }}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <motion.div
          ref={headingRef}
          initial={{ opacity: 0, y: 24 }}
          animate={headingInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="text-center mb-16"
        >
          <p className="text-gold tracking-[0.3em] text-xs uppercase mb-4 font-medium">
            Client Stories
          </p>
          <h2 className="section-heading">What Our Clients Say</h2>
          <div className="gold-divider" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <TestimonialCard key={t.name} t={t} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
